const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t" data-test-id="layout-footer">
      <div
        className="container mx-auto px-4 py-8"
        data-test-id="footer-container"
      >
        <div
          className="text-center text-gray-600"
          data-test-id="footer-content"
        >
          <p data-test-id="footer-copyright">
            &copy; 2024 RPX Loan Pricing Platform. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
